import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b99aa566&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b99aa566')) {
      api.createRecord('b99aa566', component.options)
    } else {
      api.reload('b99aa566', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b99aa566&", function () {
      api.rerender('b99aa566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29hNpCbkBS5Ud/JS/offershelp.vue"
export default component.exports